import React from 'react';

const OtherResearchContentForm = ({ isOpen, onClose, onSubmit, name, setName, score, setScore, isEditing }) => {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-box" style={{ width: '90%', maxWidth: '650px' }}>
                <div className="modal-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <h3 style={{ margin: 0, paddingRight: '20px', lineHeight: '1.4' }}>
                        <i className={isEditing ? "fa-solid fa-pen-to-square" : "fa-solid fa-plus-circle"} style={{ marginRight: '8px' }}></i>
                        {isEditing ? "Cập nhật Danh mục" : "Thêm mới Danh mục"}
                    </h3>
                    <button className="close-btn" onClick={onClose} style={{ fontSize: '26px', lineHeight: '1', flexShrink: 0, marginTop: '-2px' }}>
                        &times;
                    </button>
                </div>

                <div className="modal-body" style={{ padding: '25px' }}>
                    <form id="otherResearchForm" onSubmit={onSubmit}>
                        <div className="form-group" style={{ marginBottom: '20px' }}>
                            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>
                                Nội dung NCKH <span className="text-red">*</span>
                            </label>
                            <textarea
                                className="form-input"
                                rows="4"
                                style={{ resize: 'vertical' }}
                                placeholder="Nhập chi tiết nội dung NCKH"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                autoFocus
                            />
                        </div>
                        <div className="form-group">
                            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>
                                Điểm NCKH <span className="text-red">*</span>
                            </label>
                            <input
                                type="number"
                                step="0.0001"
                                className="form-input"
                                placeholder="0"
                                value={score}
                                onChange={(e) => setScore(e.target.value)}
                            />
                        </div>
                    </form>
                </div>

                <div className="modal-footer" style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                    <button type="button" className="btn-cancel" onClick={onClose}>
                        <i className="fa-solid fa-xmark" style={{ marginRight: '6px' }}></i> Hủy
                    </button>
                    <button type="submit" form="otherResearchForm" className="btn-submit">
                        <i className="fa-solid fa-check" style={{ marginRight: '6px' }}></i> Hoàn tất
                    </button>
                </div>
            </div>
        </div>
    );
};

export default OtherResearchContentForm;